import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { PropType } from 'vue'
import type { ResourcesChildrenTree } from '@y/types'
import DrawerNavItem from './DrawerNavItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerNav',
  props: {
  menus: {
    type: Array as PropType<ResourcesChildrenTree[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "unique-opened": false,
    class: "el-menu-vertical"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menus, (menu) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: menu.urlPath
        }, [
          (menu.type === '1' || menu.type === '5')
            ? (_openBlock(), _createBlock(DrawerNavItem, _mergeProps({
                key: 0,
                menu: menu
              }, { ref_for: true }, _ctx.$attrs), null, 16, ["menu"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}
}

})